<template>
<svg data-svg-lvl-3="edge-top-slice" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Крышка_Срез"><path :style="{ fill: params.sliceColor }"  class="tsl-c-1" d="M33.7049,231.7234v-21.447c0-5.2467,4.2533-9.5,9.5-9.5h424.7523c.6793.0001,1.235-.5556,1.235-1.2349v-3.3913c0-.682-.558-1.24-1.24-1.24H41.8387c-7.732,0-14,6.268-14,14v24.1797c0,7.732,6.268,14,14,14h426.1185c.6793,0,1.235-.5558,1.235-1.235v-3.3963c0-.6793-.5558-1.235-1.235-1.235H43.2049c-5.2467,0-9.5-4.2534-9.5-9.5001Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.tsl-c-1{fill:gray;stroke:#232728;stroke-miterlimit:2;stroke-width:1.1415px;}.tsl-c-2{opacity:.3;}.tsl-c-3{fill:#64ff00;stroke-width:0px;}</style>

